// Shared singleton state for the Amplitude session-replay lifecycle.
export const sessionReplayState = {
  active: false,
};

// Updating this list changes which sessions are recorded
export const SIGNUP_REPLAY_TRIGGER_EVENTS = new Set<string>([
  'View Sign Up Modal',
]);
